export const removeClasses = (classList: DOMTokenList, classes: string): void =>
  classList.remove(...classes.split(' '));

export const addClasses = (classList: DOMTokenList, classes: string): void => classList.add(...classes.split(' '));
